var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPropertyCreated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 0.833496V3.3335H19.1666V5.00016H16.6666V7.50016H14.9999V5.00016H12.4999V3.3335H14.9999V0.833496H16.6666ZM9.99992 10.8335C10.9166 10.8335 11.6666 10.0835 11.6666 9.16683C11.6666 8.25016 10.9166 7.50016 9.99992 7.50016C9.08325 7.50016 8.33325 8.25016 8.33325 9.16683C8.33325 10.0835 9.08325 10.8335 9.99992 10.8335ZM11.6666 2.7085V5.8335H14.1666V8.3335H16.5999C16.6416 8.6585 16.6666 8.99183 16.6666 9.3335C16.6666 12.1002 14.4416 15.3752 9.99992 19.1668C5.55825 15.3752 3.33325 12.1002 3.33325 9.3335C3.33325 5.1835 6.49992 2.50016 9.99992 2.50016C10.5666 2.50016 11.1249 2.56683 11.6666 2.7085Z",
    fill: "#248EB4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyCreated);
export default __webpack_public_path__ + "static/media/property_created.877ce86b4d20381871ab3206a01eb794.svg";
export { ForwardRef as ReactComponent };